import { Button, CardBody, CardHeader, Heading, Main, Paragraph, Text } from 'grommet'
import { MotionBox } from './Motion'
import { AnimatePresence } from 'framer-motion'
import { FormClose } from 'grommet-icons'
import React, { useEffect } from 'react'
import TimeAgo from 'react-timeago/lib'

const ToastCard = ({ toast, index, removeAction }) => {
  const typeColors = { success: 'status-ok', error: 'status-critical', info: 'mesh-accent-blue' }

  useEffect(() => {
    const timer =
      toast.timeout &&
      setTimeout(() => {
        removeAction(toast.id)
      }, toast.timeout)
    return () => clearTimeout(timer)
  }, [])
  return (
    <MotionBox
      elevation={'large'}
      pad={{ left: 'medium', right: 'small', vertical: 'small' }}
      width={'medium'}
      margin={{ left: 'xsmall', bottom: 'xsmall' }}
      exit={{ opacity: 0, y: 300 }}
      variants={{
        collapsed: { opacity: 0, y: 300 },
        open: { opacity: 1, y: 0 }
      }}
      transition={{ type: 'spring', duration: 0.5 }}
      flex={false}
      round={'xsmall'}
      background={'dark-1'}
      gap={'xsmall'}
    >
      <CardHeader>
        <Heading level={6} color={typeColors[toast.type]} margin={'none'}>
          {toast.title} 
        </Heading>

        <Button
          size={'small'}
          color={'dark-1'}
          icon={<FormClose size={'16px'} color={'light-6'} />}
          onClick={() => removeAction(index)}
          hoverIndicator
          plain={false}
        />
      </CardHeader>
      <CardBody pad={{ bottom: 'medium' }} gap={'small'}>
        <Paragraph margin="none" color="light-3" size={'small'}>
          {toast.message}
        </Paragraph>
        <Text size={'small'} color={'dark-6'}>
          <TimeAgo date={toast.date} />
        </Text>
      </CardBody>
    </MotionBox>
  )
}
const Toasts = ({ toasts, removeAction }) => {
  return (
    <Main width={'large'} round={{ corner: 'top', size: 'small' }} overflow={'hidden'}>
      <MotionBox
        flex={'grow'}
        gap={'xsmall'}
        variants={{
          open: { opacity: 1, y: 0 },
          collapsed: { opacity: 0, y: 0 }
        }}
        initial="collapsed"
        animate="open"
        exit="collapsed"
        transition={{
          type: 'spring',
          duration: 0.7,
          staggerChildren: 0.07,
          delayChildren: 0.2
        }}
      >
        <AnimatePresence initial={true}>
          {toasts.map((toast, index) => (
            <ToastCard
              key={toast.date.getTime()}
              toast={toast}
              index={index}
              removeAction={removeAction}
            />
          ))}
        </AnimatePresence>
      </MotionBox>
    </Main>
  )
}
export default Toasts
